class CranHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.cran-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.cran-hero__dot'));
    this.current = 0;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.slideTarget, 10));
      });
    });

    if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion) {
        this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), 6000);
      }
    }
  }

  goTo(index) {
    if (!this.slides[index] || index === this.current) return;
    this.slides[this.current].hidden = true;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');

    this.current = index;
    this.slides[this.current].hidden = false;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }
}

customElements.define('cran-hero-slideshow', CranHeroSlideshow);
